/* eslint-disable @typescript-eslint/no-explicit-any */
import SntAddFilterIcon from "@icons/SntAddFilterIcon";
import SntRemoveFilterIcon from "@icons/SntRemoveFilterIcon";
import { LanguageKey } from "@/types/generated/LanguageKey";
import { translate } from "@/hooks/useLanguage";
import { getCellFilter } from "../../../utils/cellUtils";

interface CellFilterProps {
  cell: any;
  row: any;
  isDisabbledAddFilter: boolean;
  restrictedFilters?: string[];
  filterVisibleKeys?: string[];
  filterMap?: Record<string, unknown>;
  onFilterClicked?: (
    action: string,
    columnKey: string,
    filterKeys: string[],
    cellValue: any[] | null
  ) => void;
}

export const CellFilter = ({
  cell,
  row,
  isDisabbledAddFilter,
  restrictedFilters,
  filterVisibleKeys,
  filterMap = {},
  onFilterClicked,
}: CellFilterProps) => {
  const shouldShow =
    !isDisabbledAddFilter &&
    !cell.column.isGrouped &&
    cell.column.filterKeys?.length > 0 &&
    (!restrictedFilters ||
      restrictedFilters.length === 0 ||
      !restrictedFilters?.includes(cell.column.filterKeys[0]));

  if (!shouldShow) return null;

  const handleFilterForValue = (e: React.MouseEvent) => {
    e.preventDefault();
    e.stopPropagation();

    const cellValue = getCellFilter(cell.column, row.original);

    onFilterClicked?.(
      "FILTER_FOR_VALUE",
      cell.column.key,
      cell.column.filterKeys,
      cellValue?.length > 0 ? cellValue : null
    );
  };

  const handleFilterOutValue = (e: React.MouseEvent) => {
    e.preventDefault();
    e.stopPropagation();
    const cellValue = getCellFilter(cell.column, row.original);
    onFilterClicked?.(
      "FILTER_OUT_VALUE",
      cell.column.key,
      cell.column.filterKeys,
      cellValue?.length > 0 ? cellValue : null
    );
  };

  return (
    <span className="cell-filter">
      <SntAddFilterIcon
        className={`me-1 ${
          filterVisibleKeys?.includes(cell.column.filterKeys[0]) ? "d-none" : ""
        }`}
        title={translate(LanguageKey.filter_for_value_key)}
        onClick={handleFilterForValue}
      />
      {(!filterMap || filterMap[cell.column.filterKeys[0]] !== "MULTI_STRING") && (
        <SntRemoveFilterIcon
          title={translate(LanguageKey.filter_out_value_key)}
          onClick={handleFilterOutValue}
        />
      )}
    </span>
  );
};
